// useBackButtonHandler.ts
import { useEffect } from 'react';
import { BackHandler } from 'react-native';

export const useBackButtonHandler = (callback: () => boolean, dependencies: any[] = []) => {
  useEffect(() => {
    const handleBackButton = () => {
      return callback();
    };

    const backHandler = BackHandler.addEventListener('hardwareBackPress', handleBackButton);

    return () => {
      backHandler.remove();
    };
  }, dependencies);
};